<template>
  <div>
    <div v-if="adLoading" class="my-3 text-center">
      <v-progress-circular indeterminate />
    </div>
    <v-row v-else>
      <v-col
        v-for="ad of ads"
        :key="ad.id"
        sm="6"
        lg="4"
        cols="12"
      >
        <v-card style="height: 100%">
          <div class="pa-4">
            <Ad :item="ad" />
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Ad from "../components/Ad.vue";
export default {
  components: { Ad },
  mounted(){
    this.getAds();
  }
};
</script>

<style>
</style>